import React from 'react';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';
import useComponentDidMount from 'Hooks/useComponentDidMount';


export const useOnboardingCapacity = (onboardingCapacityRelationship) => {
  const [loading, setLoading] = React.useState(true);
  const [loadingError, setLoadingError] = React.useState(null);
  const [submitting, setSubmitting] = React.useState(false);
  const [onboardingCapacityResource, setOnboardingCapacityResource] = React.useState(null);
  const { displayErrorMessage } = useSnackbarContext();
  const [newOnboardingCapacityItemResource, setNewOnboardingCapacityItemResource] = React.useState(null);

  const loadOnboardingCapacity = async () => {
    try {
      const [onboardingCapacity] = await onboardingCapacityRelationship.getRelated();
      setOnboardingCapacityResource(onboardingCapacity);
      const newItem = onboardingCapacity.attr('items').create();
      setNewOnboardingCapacityItemResource(newItem);
    } catch (e) {
      setLoadingError(e);
      displayErrorMessageWithChecks(e, displayErrorMessage, 'Failed to load onboarding capacity');
    } finally {
      setLoading(false);
    }
  };

  const deleteOnboardingCapacityItem = async (item) => {
    try {
      setSubmitting(true);
      await item.delete();
      await loadOnboardingCapacity();
    } catch (e) {
      displayErrorMessageWithChecks(e, displayErrorMessage, 'Failed to delete new onboarding capacity');
    } finally {
      setSubmitting(false);
    }
  };

  const submitNewOnboardingCapacityItem = async () => {
    try {
      setSubmitting(true);
      await newOnboardingCapacityItemResource.submit();
      await loadOnboardingCapacity();
    } catch (e) {
      displayErrorMessageWithChecks(e, displayErrorMessage, 'Failed to add new onboarding capacity');
    } finally {
      setSubmitting(false);
    }
  };

  useComponentDidMount(async () => {
    await loadOnboardingCapacity();
  });

  return {
    loading,
    loadingError,
    submitting,
    onboardingCapacityResource,
    newOnboardingCapacityItemResource,
    deleteOnboardingCapacityItem,
    loadOnboardingCapacity,
    submitNewOnboardingCapacityItem,
  };
};
